import logo from './logo.svg';
import './App.css';
import { Routes, Route, useParams } from "react-router-dom"
import { art_projects, client_projects } from "./projects.js"
import React from 'react';
import {useEffect, useState} from "react";
import Draggable from 'react-draggable'; // The default

const Single = () => {
  const params = useParams();
  console.log(params)
  const [galleryImg, setGalleryImg] = useState("");
  const [sliderI, setSliderI] = useState(0);
  const newObj = [...art_projects, ...client_projects];
  const obj = newObj.find(element => element.slug == params.workId);
  useEffect(() => {
    setGalleryImg(obj.img[sliderI]);
  }, [])
  useEffect(() => {
    const timer = setTimeout(() => {
      setGalleryImg(obj.img[sliderI]);
      if(sliderI >= obj.img.length - 1) {
        setSliderI(0)
      } else {
        setSliderI(sliderI + 1);
      }
    }, 1500);
    return () => clearTimeout(timer);
  });
  return (
<div className="single">
  <div className='title'>
    {obj.title} ({obj.year})
    </div>
    <div className="medium">
      {obj.medium}
    </div>
    {obj.img &&
      <React.Fragment>
        <div className='gallery'>
          <div className="img_container">
            {galleryImg.length > 0 &&
            <img src={galleryImg}></img>
            }
            </div>
        </div>
      </React.Fragment>
    }
    <div className='text' dangerouslySetInnerHTML={{__html: obj.desc}}>
    </div>
    </div>
  );
}

export default Single;
